import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { CalendarYear } from '@klopotun/contracts';
import { summaryQueries } from './summary-queries.js';

export const useCalendarQuery = (year: number | null = null): UseQueryResult<CalendarYear> =>
  useQuery(summaryQueries.calendar(year));
